import React, { useState } from 'react'
import { Modal, Form, Input } from 'antd'

const { TextArea } = Input

const CreateMenuModal = ({ visible, onCancel, onOk, form }) => {
  const [loading, setLoading] = useState(false)

  const handleOk = () => {
    form.validateFields((err, values) => {
      if (!err) {
        setLoading(true)
        onOk(values)
        form.resetFields()
        setLoading(false)
        onCancel()
      }
    })
  }

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title='Create New Menu'
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText='Create Menu'
      cancelText='Cancel'
      width={500}
    >
      <Form layout='vertical' requiredMark={false}>
        <Form.Item
          label='Menu Name'
          rules={[
            { required: true, message: 'Please enter a menu name' },
            { min: 2, message: 'Menu name must be at least 2 characters' },
            { max: 80, message: 'Menu name must be less than 80 characters' },
          ]}
        >
          {form.getFieldDecorator('name', {
            rules: [
              { required: true, message: 'Please enter a menu name' },
              { min: 2, message: 'Menu name must be at least 2 characters' },
              { max: 80, message: 'Menu name must be less than 80 characters' },
            ],
          })(
            <Input
              placeholder='e.g., Lunch Menu, Dinner Menu, Kids Menu'
              maxLength={80}
            />,
          )}
        </Form.Item>

        <Form.Item label='Description (Optional)'>
          {form.getFieldDecorator('description', {
            rules: [
              {
                max: 500,
                message: 'Description must be less than 500 characters',
              },
            ],
          })(
            <TextArea
              placeholder='Add a description for this menu...'
              rows={3}
              maxLength={500}
              showCount
            />,
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Form.create({ name: 'create_menu' })(CreateMenuModal)
